import camelCase from '../lib/camelCase';
import Immutable from 'immutable';

function transformRegionsFromApi(payload) {
    const result = camelCase(payload);
    if (result.createdAt) result.createdAt = new Date(result.createdAt);
    return result;
}

export function get(api) {
    return api.get(api.url('regions/all'), {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformRegionsFromApi(response.payload))
                : response;
        },
    });
}

export default {
    get,
};
